import * as Function from "../Function";
import * as Error from "../Error";
import * as ErrorCode from "../ErrorCode";
import { Option, some, none } from "fp-ts/lib/Option";

export const positiveDecimal: Function.TValidationFunction = (value: unknown): Option<Error.TValidationError> =>
    typeof value === "undefined" || (typeof value === "number" && value >= 0)
        ? none
        : some([[ErrorCode.validationErrorCodeConstants.POSITIVE_DECIMAL_VALIDATION]]);
